import React, { useState, useEffect } from 'react';
import apiService from '../services/api';

interface Domain {
  id: string;
  name: string;
  description: string;
}

interface DomainSelectorProps {
  onDomainChange: (domainId: string) => void;
  currentDomain: string;
}

const DomainSelector: React.FC<DomainSelectorProps> = ({ onDomainChange, currentDomain }) => {
  const [domains, setDomains] = useState<Domain[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDomains = async () => {
      try {
        setLoading(true);
        const response = await apiService.getDomains();
        setDomains(response);
      } catch (err) {
        console.error('Error fetching domains:', err);
        setError('Failed to load domains');
      } finally {
        setLoading(false);
      }
    };

    fetchDomains();
  }, []);

  const handleDomainChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onDomainChange(event.target.value);
  };

  if (loading) {
    return <div className="domain-selector">Loading domains...</div>;
  }

  if (error) {
    return <div className="domain-selector error">Error: {error}</div>;
  }

  return (
    <div className="domain-selector">
      <label htmlFor="domain-select">Domain: </label>
      <select
        id="domain-select"
        value={currentDomain}
        onChange={handleDomainChange}
        className="domain-select"
      >
        {domains.map(domain => (
          <option key={domain.id} value={domain.id}>
            {domain.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DomainSelector;